//読み込み時は非表示
$(function(){
  //カテゴリーの見出しをクリックしたらチェックボックスが表示される。
  $('#category .search__item--head').on('click',function(){
    $('#category').toggleClass('open');
    $('#category .search__item--list').toggleClass('open-list');
  });
  //エリアの見出しをクリックしたらチェックボックスが表示される。
  $('#area .search__item--head').on('click',function(){
    $('#area').toggleClass('open');
    $('#area .search__item--list').toggleClass('open-list');
  });
  $('#appeal .search__item--head').on('click',function(){
    $('#appeal').toggleClass('open');
    $('#appeal .search__item--list').toggleClass('open-list');
  });
});